import React from "react";
import { Route } from "react-router-dom";

const Protected = ({
  user,
  setUser,
  publicRoutes: Public,
  children,
  ...rest
}) => {
  const isAuth = user || false;
  return (
    <Route
      {...rest}
      render={() =>
        isAuth ? <>{children}</> : <Public setUser={setUser} />
      }
    />
  );
};
export default Protected;
